import Animation from "../../app/Animation";
import store from "../../app/store";


class RadarStaticAnimation extends Animation{
    getCalendar(){
        return store.get("radarCalendar");
    }

    getTimestamp(){
        return store.get("radarTimestamp");
    }

    setTimestamp(timestamp){
        return store.set("radarTimestamp", timestamp);
    }

}

export default RadarStaticAnimation;
